export const PROFILE_UPDATES_PAGE_SIZES = [15, 25, 50, 100]
export const PROFILE_UPDATES_DEFAULT_ROWS = 25
export const PROFILE_UPDATES_MIN_ROWS = 0